{
  "AUDIT_LOGS": {
    "HEADER": "Audit Logovi",
    "HEADER_BTN_TXT": "Dodaj Audit Logove",
    "LOADING": "Dohvat Audit Logova",
    "DESCRIPTION": "Audit Logovi bilježe aktivnosti na vašem računu i omogućuju praćenje i reviziju vašeg računa, tima ili usluga.",
    "LEARN_MORE": "Saznajte više o Audit Logovima",
    "SEARCH_404": "Ne postoji rezultat za zadano pretraživanje",
    "SIDEBAR_TXT": "<p><b>Audit Logovi</b> </p><p> Audit Logovi su tragovi događaja i akcija u sustavu. </p>",
    "LIST": {
      "404": "Na ovom korisničkom računu nema dostupnih Audit Logova.",
      "TITLE": "Upravljanje Audit Logovima",
      "DESC": "Audit Logovi su tragovi događaja i akcija u sustavu.",
      "TABLE_HEADER": {
        "ACTIVITY": "Korisnik",
        "TIME": "Akcija",
        "IP_ADDRESS": "IP adresa"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "Audit Logovi su uspješno dohvaćeni",
      "ERROR_MESSAGE": "Neuspješno spajanje na Woot Server, Molimo pokušajte kasnije"
    },
    "DEFAULT_USER": "Sustav",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} je stvorio novo pravilo automatizacije (#{id})",
      "EDIT": "{agentName} je ažurirao pravilo automatizacije (#{id})",
      "DELETE": "{agentName} je izbrisao pravilo automatizacije (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} je pozvao {invitee} na račun s ulogom {role}",
      "EDIT": {
        "SELF": "{agentName} je promijenio svoje {attributes} u {values}",
        "OTHER": "{agentName} je promijenio {attributes} korisnika {user} u {values}",
        "DELETED": "{agentName} je promijenio {attributes} izbrisanog korisnika u {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} je stvorio novi sandučić (#{id})",
      "EDIT": "{agentName} je ažurirao sandučić (#{id})",
      "DELETE": "{agentName} je izbrisao sandučić (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} je stvorio novi webhook (#{id})",
      "EDIT": "{agentName} je ažurirao webhook (#{id})",
      "DELETE": "{agentName} je izbrisao webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} se prijavio",
      "SIGN_OUT": "{agentName} se odjavio"
    },
    "TEAM": {
      "ADD": "{agentName} je stvorio novi tim (#{id})",
      "EDIT": "{agentName} je ažurirao tim (#{id})",
      "DELETE": "{agentName} je izbrisao tim (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} je stvorio novi makro (#{id})",
      "EDIT": "{agentName} je ažurirao makro (#{id})",
      "DELETE": "{agentName} je izbrisao makro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} je dodao {user} u sandučić (#{inbox_id})",
      "REMOVE": "{agentName} je uklonio {user} iz sandučića (#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} je dodao {user} u tim (#{team_id})",
      "REMOVE": "{agentName} je uklonio {user} iz tima (#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} je ažurirao konfiguraciju računa (#{id})"
    },
    "CONVERSATION": {
      "ADD": "{agentName} je stvorio razgovor (#{id})",
      "EDIT": "{agentName} je ažurirao razgovor (#{id}): {changes}"
    },
    "CONTACT": {
      "ADD": "{agentName} je stvorio kontakt (#{id})",
      "EDIT": "{agentName} je ažurirao kontakt (#{id}): {attributes}"
    }
  }
}
